import { render, staticRenderFns } from "./ProjectRow.vue?vue&type=template&id=40e782cc"
import script from "./ProjectRow.vue?vue&type=script&lang=ts"
export * from "./ProjectRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports